import React from "react";
import { btn3d } from "../../styles/buttonStyles";

/* 변형 이름 → 입체 스타일 키 */
const VARIANT_MAP = {
  primary: "primary",
  secondary: "outline",
  ghost: "outline",
  white: "white",
  teal: "teal",
  success: "success",
  danger: "danger",
};

export default function Button({
  children,
  onClick,
  disabled = false,
  variant = "primary", // primary | secondary | ghost | white | teal | success | danger
  size = "md",
  fullWidth = true,
  loading = false,
  icon,
  style = {},
  // 구버전 호출 호환: <Button darkMode small secondary> 형태 흡수 (DOM 누출 방지)
  darkMode = false,
  small,
  secondary,
  ...props
}) {
  if (small) size = "sm";
  if (secondary) variant = "secondary";

  const sizes = {
    sm: { padding: "11px 16px", minHeight: 46, borderRadius: 13 },
    md: { padding: "14px 20px", minHeight: 52, borderRadius: 15 },
    lg: { padding: "16px 28px", minHeight: 56, borderRadius: 16 },
  };
  const sizeClass = { sm: "text-sm", md: "text-base", lg: "text-base" };

  const s = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    fontWeight: 800,
    letterSpacing: "0.01em",
    whiteSpace: "nowrap",
    outline: "none",
    ...sizes[size],
    ...btn3d(VARIANT_MAP[variant] || "primary", darkMode),
    width: fullWidth ? "100%" : "auto",
    opacity: disabled || loading ? 0.55 : 1,
    ...style,
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      className={`btn3d ${sizeClass[size]}`}
      style={s}
      {...props}
    >
      {loading && (
        <span
          style={{
            width: 18,
            height: 18,
            border: "2px solid rgba(255,255,255,0.3)",
            borderTopColor: "#fff",
            borderRadius: "50%",
            animation: "spin 0.7s linear infinite",
          }}
        />
      )}
      {!loading && icon && <span className="text-base" style={{ lineHeight: 1 }}>{icon}</span>}
      <span>{children}</span>
    </button>
  );
}
